import { guideAppSteps, guideWebSteps } from "@/mocks/siteData";
import SectionHeading from "@/pages/home/components/SectionHeading";

interface StepListProps {
  icon: string;
  title: string;
  subtitle: string;
  steps: { title: string; desc: string }[];
}

function StepList({ icon, title, subtitle, steps }: StepListProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
      <div className="flex items-center gap-3">
        <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
          <i className={`${icon} text-2xl`} aria-hidden="true" />
        </span>
        <div>
          <h3 className="font-heading text-lg text-foreground-950">{title}</h3>
          <p className="text-xs text-foreground-500">{subtitle}</p>
        </div>
      </div>
      <ol className="mt-6 flex flex-col gap-5">
        {steps.map((step, i) => (
          <li key={step.title} className="flex gap-4">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-sm text-background-50">
              {i + 1}
            </span>
            <div className="pt-0.5">
              <h4 className="text-sm font-medium text-foreground-950">
                <a href="#guide" className="hover:text-primary-600">
                  {step.title}
                </a>
              </h4>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="使用教程"
          title="两条路，从打开到读上，最多四步"
          desc="不论你打算直接在网页上看，还是下载客户端长期追更，流程都不复杂。下面把两条路径分别拆开写清楚，第一次使用也能照着完成。"
        />

        <div className="reveal mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <StepList
            icon="ri-global-line"
            title="网页版在线阅读"
            subtitle="免安装 · 打开即读 · 适合临时追更"
            steps={guideWebSteps}
          />
          <StepList
            icon="ri-smartphone-line"
            title="客户端下载使用"
            subtitle="多端同步 · 离线缓存 · 适合长期追更"
            steps={guideAppSteps}
          />
        </div>
      </div>
    </section>
  );
}